import api from "@/libs/api";

const operationState = {
  status: [],
  groupName: "",
  seach: "",
  groupId:"",
  ani: "不限制",
  ani2: "不限制",
  ani3: "不限制",
  ani4: "不限制",
};

const operationdata = {
  state: operationState,
  mutations: {
    SET_STATUS(state, data) {
      state.status = data;
    },
    SET_INPUT(state, data) {
      state.groupName = data;
    },
    SET_ani(state,data){
      state.ani = data
    },
    SET_ani2(state,data){
      state.ani2 = data
    },
    SET_ani3(state,data){
      state.ani3 = data
    },
    SET_ani4(state,data){
      state.ani4 = data
    },
  },
  actions: {
    
  }
};

export default operationdata;



// WEBPACK FOOTER //
// ./src/store/modules/operation-plan.js